(function () {
  var FULL_POSTCODE_RE = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i;
  var OUTCODE_RE = /^[A-Z]{1,2}\d[A-Z\d]?$/i;
  var GEOCODE_DEBOUNCE_MS = 600;
  var FALLBACK_NEAREST_COUNT = 10;
  var EARTH_RADIUS_MILES = 3958.8;

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function toRad(deg) {
    return (deg * Math.PI) / 180;
  }

  function distanceMiles(lat1, lng1, lat2, lng2) {
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_MILES * c;
  }

  function addTileLayer(map, tileStyle, jawgToken) {
    if (tileStyle === 'jawg_streets' && jawgToken) {
      L.tileLayer('https://{s}.tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=' + encodeURIComponent(jawgToken), {
        minZoom: 0,
        maxZoom: 22,
        subdomains: 'abcd',
        attribution: '<a href="https://jawg.io" target="_blank" rel="noopener">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank" rel="noopener">&copy; OpenStreetMap</a> contributors'
      }).addTo(map);
      return;
    }

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
  }

  function pinIcon() {
    return L.divIcon({
      className: 'stockists-map__pin-wrap',
      html: '<svg class="stockists-map__pin" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg"><path fill="#F20102" stroke="#ffffff" stroke-width="1.5" d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20c0-6.6-5.4-12-12-12z"/><circle cx="12" cy="12" r="5" fill="#ffffff"/></svg>',
      iconSize: [24, 32],
      iconAnchor: [12, 32],
      popupAnchor: [0, -30]
    });
  }

  // Free, keyless UK postcode/place lookup — no rate-limit or billing concerns for this volume.
  function geocodeQuery(query) {
    var trimmed = query.trim();
    var compact = trimmed.replace(/\s+/g, '').toUpperCase();
    var url;

    if (FULL_POSTCODE_RE.test(compact)) {
      url = 'https://api.postcodes.io/postcodes/' + encodeURIComponent(compact);
    } else if (OUTCODE_RE.test(compact)) {
      url = 'https://api.postcodes.io/outcodes/' + encodeURIComponent(compact);
    } else {
      url = 'https://api.postcodes.io/places?limit=1&q=' + encodeURIComponent(trimmed);
    }

    return fetch(url)
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (json) {
        if (!json || json.status !== 200 || !json.result) return null;
        var result = Array.isArray(json.result) ? json.result[0] : json.result;
        if (!result || typeof result.latitude !== 'number' || typeof result.longitude !== 'number') return null;
        return { lat: result.latitude, lng: result.longitude };
      })
      .catch(function () {
        return null;
      });
  }

  function initStockistsMap(mapEl) {
    if (mapEl.dataset.initialized === 'true') return;
    mapEl.dataset.initialized = 'true';

    var idSuffix = mapEl.id.replace('StockistsMap-', '');
    var dataScript = document.getElementById('StockistsData-' + idSuffix);
    var searchInput = document.getElementById('StockistSearch-' + idSuffix);
    var clearBtn = document.getElementById('StockistSearchClear-' + idSuffix);
    var countEl = document.getElementById('StockistCount-' + idSuffix);
    var emptyEl = document.getElementById('StockistEmpty-' + idSuffix);
    var listEl = document.getElementById('StockistList-' + idSuffix);
    if (!dataScript || !listEl) return;

    var stockists;
    try {
      stockists = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var defaultLat = parseFloat(mapEl.dataset.centerLat) || 54.5;
    var defaultLng = parseFloat(mapEl.dataset.centerLng) || -3.5;
    var defaultZoom = parseInt(mapEl.dataset.zoom, 10) || 6;
    var radiusMiles = parseFloat(mapEl.dataset.radiusMiles) || 30;

    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([defaultLat, defaultLng], defaultZoom);
    addTileLayer(map, mapEl.dataset.tileStyle, mapEl.dataset.jawgToken);

    var originalOrder = Array.prototype.slice.call(listEl.querySelectorAll('.stockists-map__item'));
    var entries = [];

    function setActiveItem(activeLi) {
      originalOrder.forEach(function (li) { li.classList.remove('stockists-map__item--active'); });
      if (activeLi) activeLi.classList.add('stockists-map__item--active');
    }

    function setDistanceLabel(li, miles) {
      if (!li) return;
      var label = li.querySelector('.stockists-map__item-distance');
      if (miles == null) {
        if (label) label.remove();
        return;
      }
      if (!label) {
        label = document.createElement('p');
        label.className = 'stockists-map__item-distance';
        li.appendChild(label);
      }
      label.textContent = miles.toFixed(1) + ' miles away';
    }

    originalOrder.forEach(function (li, i) {
      var s = stockists[i];
      var marker = null;

      if (s && typeof s.lat === 'number' && typeof s.lng === 'number') {
        var popupParts = ['<div class="stockists-map__popup"><strong>' + escapeHtml(s.name) + '</strong>'];
        if (s.address) popupParts.push(escapeHtml(s.address) + '<br>');
        var townLine = [s.town, s.postcode].filter(Boolean).join(', ');
        if (townLine) popupParts.push(escapeHtml(townLine) + '<br>');
        if (s.country) popupParts.push(escapeHtml(s.country));
        if (s.notes) popupParts.push('<br><em>' + escapeHtml(s.notes) + '</em>');
        if( s.email) popupParts.push('<br><a class="stockists-map__popup-email" href="mailto:' + escapeHtml(s.email) + '">' + escapeHtml(s.email) + '</a>');
        if( s.phone) popupParts.push('<br><a class="stockists-map__popup-phone" href="tel:' + escapeHtml(s.phone) + '">' + escapeHtml(s.phone) + '</a>'); 
        popupParts.push(
          '<br><a class="stockists-map__popup-directions" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
            encodeURIComponent(s.lat + ',' + s.lng) +
            '">Get directions</a></div>'
        );

        marker = L.marker([s.lat, s.lng], { icon: pinIcon() }).addTo(map);
        marker.bindPopup(popupParts.join(''));

        li.addEventListener('click', function () {
          map.setView([s.lat, s.lng], Math.max(map.getZoom(), 11));
          marker.openPopup();
          setActiveItem(li);
        });
      }

      entries.push({ data: s, li: li, marker: marker });
    });

    function showMarker(entry, show) {
      if (!entry.marker) return;
      if (show && !map.hasLayer(entry.marker)) entry.marker.addTo(map);
      else if (!show && map.hasLayer(entry.marker)) map.removeLayer(entry.marker);
    }

    function fitToMarkers(visibleEntries) {
      var withMarkers = visibleEntries.filter(function (e) { return e.marker; });
      if (!withMarkers.length) return;
      if (withMarkers.length === 1) {
        map.setView(withMarkers[0].marker.getLatLng(), 12);
        return;
      }
      var group = L.featureGroup(withMarkers.map(function (e) { return e.marker; }));
      map.fitBounds(group.getBounds().pad(0.2));
    }

    function resetOrder() {
      originalOrder.forEach(function (li) { listEl.appendChild(li); });
    }

    function updateCountText(text) {
      if (countEl) countEl.textContent = text;
    }

    // Instant substring match on name/town/postcode/country — no network call, works while typing.
    function applyTextFilter(query) {
      resetOrder();
      entries.forEach(function (entry) { setDistanceLabel(entry.li, null); });

      var visible = [];
      entries.forEach(function (entry) {
        var haystack = entry.li ? entry.li.dataset.search || '' : '';
        var matches = query === '' || haystack.indexOf(query) !== -1;
        if (entry.li) entry.li.classList.toggle('stockists-map__item--hidden', !matches);
        showMarker(entry, matches);
        if (matches) visible.push(entry);
      });

      updateCountText(visible.length === entries.length ? entries.length + ' stockists' : visible.length + ' of ' + entries.length + ' stockists');
      if (emptyEl) emptyEl.hidden = visible.length !== 0;

      if (query === '') fitToMarkers(entries);
      else fitToMarkers(visible);
    }

    // Distance-sorted, radius-filtered view once the query resolves to a real place.
    function applyRadiusFilter(origin) {
      var withDistance = entries
        .filter(function (entry) { return entry.marker; })
        .map(function (entry) {
          return { entry: entry, miles: distanceMiles(origin.lat, origin.lng, entry.data.lat, entry.data.lng) };
        })
        .sort(function (a, b) { return a.miles - b.miles; });

      var withinRadius = withDistance.filter(function (r) { return r.miles <= radiusMiles; });
      var showing = withinRadius.length ? withinRadius : withDistance.slice(0, FALLBACK_NEAREST_COUNT);
      var showingIds = {};
      showing.forEach(function (r) { showingIds[r.entry.li.dataset.index] = r.miles; });

      entries.forEach(function (entry) {
        var isShowing = Object.prototype.hasOwnProperty.call(showingIds, entry.li.dataset.index);
        entry.li.classList.toggle('stockists-map__item--hidden', !isShowing);
        showMarker(entry, isShowing);
        setDistanceLabel(entry.li, isShowing ? showingIds[entry.li.dataset.index] : null);
      });

      // Reorder the list nearest-first; unmatched items with no marker stay hidden at the end.
      withDistance.forEach(function (r) { listEl.appendChild(r.entry.li); });
      entries.forEach(function (entry) {
        if (!entry.marker) listEl.appendChild(entry.li);
      });

      if (emptyEl) emptyEl.hidden = true;

      if (withinRadius.length) {
        updateCountText(withinRadius.length + ' stockist' + (withinRadius.length === 1 ? '' : 's') + ' within ' + radiusMiles + ' miles');
      } else {
        updateCountText('No stockists within ' + radiusMiles + ' miles — showing your ' + showing.length + ' nearest');
      }

      fitToMarkers(showing.map(function (r) { return r.entry; }));
    }

    updateCountText(entries.length + ' stockists');

    var geocodeTimer = null;
    var geocodeToken = 0;

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value;

        // Immediate text feedback while typing.
        applyTextFilter(query.trim().toLowerCase());

        if (geocodeTimer) clearTimeout(geocodeTimer);
        var trimmed = query.trim();
        if (trimmed.length < 3) return;

        var thisToken = ++geocodeToken;
        geocodeTimer = setTimeout(function () {
          geocodeQuery(trimmed).then(function (origin) {
            if (thisToken !== geocodeToken) return; // stale response — a newer search superseded this one
            if (origin) applyRadiusFilter(origin);
          });
        }, GEOCODE_DEBOUNCE_MS);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        geocodeToken++;
        if (geocodeTimer) clearTimeout(geocodeTimer);
        if (searchInput) searchInput.value = '';
        applyTextFilter('');
        setActiveItem(null);
      });
    }

    fitToMarkers(entries);
  }

  function init() {
    document.querySelectorAll('.stockists-map__map').forEach(initStockistsMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
